// extracted by mini-css-extract-plugin
export default {"container":"Modal_container__WcyG+","close":"Modal_close__OmNzF","customClose":"Modal_customClose__B43zF","box":"Modal_box__aNMTO"};